<template>
  <apex-chart ref="apexchart" v-if="categoriasChart.length > 0" height="500" type="bar" :options="chartOptions"
              :series="series"/>
</template>

<script>
import DescripcionesServicio from "@/comunes/servicios/DescripcionesServicio";

export default {
  name: "GraficoEconomicos",
  props: {
    solucionesConstructivas: {type: Array, required: true},
    resultados: {type: Array, required: true},
    tipoArea: {type: String, required: true},
    tipoResultado: {type: String, required: true},
    labelClickeable: {type: Boolean, default: false},
    esGrupoPrestacional: {type: Boolean, default: false},
  },
  computed: {
    series() {
      if (this.resultados == null || this.resultados.length == 0) return [];
      if (this.solucionesConstructivas == null || this.solucionesConstructivas.length == 0) return [];

      let interpolados = [];
      this.resultados.forEach((result) => {
        if (result.indicador.codigo.includes("INTER")
            || result.indicador.area.clase.toLowerCase().trim().includes('prestacion')) {
          interpolados.push(result);
        }
      });

      let serie1 = [];
      let serie2 = [];

      interpolados.forEach((interpolado) => {
        let tipoResultado = this.tipoResultado;

        if (interpolado.indicador.area.clase.toLowerCase().trim().includes('economicos')) {
          let resultado = this.resultados[interpolados.indexOf(interpolado)];
          let valor0 = resultado.absoluto.resultadosSolCons[0][tipoResultado];
          let valor1 = resultado.absoluto.resultadosSolCons[1][tipoResultado];
          serie1.push(valor0);
          serie2.push(valor1);
        } else {
          let esPrestacional = interpolado.indicador.area.clase.toLowerCase().trim().includes('prestacion');
          if (esPrestacional) tipoResultado = 'completo';

          let float = this.convertirAFlotante(interpolado.resultadosSolCons[0][tipoResultado]);
          if (!isNaN(float)) {
            let valSerie1 = this.convertirAFlotante(interpolado.resultadosSolCons[0][tipoResultado]) * -1;
            if (isNaN(valSerie1)) valSerie1 = 0;
            serie1.push(valSerie1 === 0 ? -0.5 : valSerie1);

            let valSerie2 = this.convertirAFlotante(interpolado.resultadosSolCons[1][tipoResultado]);
            if (isNaN(valSerie2)) valSerie2 = 0;
            serie2.push(valSerie2 === 0 ? 0.5 : valSerie2);
          } else {
            serie1.push(esPrestacional ? -0.5 : 0);
            serie2.push(esPrestacional ? 0.5 : 0);
          }
        }
      });

      return [
        {name: DescripcionesServicio.materialSolConsCorto(this.solucionesConstructivas[0]), data: serie1},
        {name: DescripcionesServicio.materialSolConsCorto(this.solucionesConstructivas[1]), data: serie2}
      ];
    },
    categorias() {
      if (this.resultados == null || this.resultados.length == 0) return null;

      let interpolados = [];
      this.resultados.forEach((result) => {
        if (result.indicador.codigo.includes("INTER") || result.indicador.area.clase.toLowerCase().trim().includes('prestacion')) {
          interpolados.push(result);
        }
      });
      let catergorias = {};
      interpolados.forEach((interpolado) => {
        if (!interpolado.indicador.area.clase.toLowerCase().trim().includes('prestacion')) {
          let float = this.convertirAFlotante(interpolado.resultadosSolCons[0][this.tipoResultado]);
          if (!isNaN(float)) {
            if (interpolado.indicador.codigo.startsWith("AI_")) {
              let impacto = interpolado.indicador.codigo
                  .replace("AI_", "")
                  .replace("_INTER", "")
                  .toUpperCase();
              let descripcion = interpolado.indicador.nombre.replace(` (${impacto})`, "");

              catergorias[impacto + ": "
              + (descripcion.length > 20 ? descripcion.substring(0, 35) + "..." : descripcion)]
                  = interpolado.indicador;
            } else {
              catergorias[interpolado.indicador.nombre] = interpolado.indicador;
            }
          }
        } else {
          catergorias[interpolado.indicador.nombre] = interpolado.indicador;
        }
      });
      return catergorias;
    },
    categoriasChart() {
      return Object.keys(this.categorias);
    },
    chartOptions() {
      if (this.categoriasChart.length == 0) return {};

      return {
        chart: {
          stacked: (this.tipoArea == 'economicos') ? false : true,
          toolbar: {
            show: false,
          },
          events: {
            click: (event) => {
              if (!this.labelClickeable || !event || !event.target) return;

              let contenido = event.target.textContent;
              if (contenido.includes("...")) contenido = contenido.split("...")[0];

              let encontrada = null;

              if (contenido.length === 0) {
                encontrada = this.categoriasChart[event.target.attributes.j.nodeValue];
              } else {
                this.categoriasChart.forEach((categoria) => {
                  const ctn = contenido.toLocaleLowerCase().replace("...", "");
                  if (ctn.startsWith(categoria.toLocaleLowerCase()) || categoria.toLocaleLowerCase().startsWith(ctn))
                    encontrada = categoria;
                });
              }

              if (encontrada != null)
                this.$emit("label:click", this.categorias[encontrada]);
            },
            mounted: () => {
              if (this.tipoArea !== 'economicos') return;

              let yaxis = this.$refs.apexchart.$el.querySelector(".apexcharts-yaxis");

              let cabeceras = yaxis.firstChild.children;

              for (let i = 0; i < cabeceras.length; i++) {
                let cabecera = cabeceras[i];

                let nodoValor = cabecera.firstChild.firstChild.nodeValue;

                let encontrada = null;
                this.categoriasChart.forEach((categoria) => {
                  if (nodoValor.toLocaleLowerCase().endsWith(categoria.toLocaleLowerCase()))
                    encontrada = categoria;
                });

                if (encontrada != null) {
                  let indicadorNombre = this.categorias[encontrada];
                  let texto = this.$t(indicadorNombre.nombre);

                  cabecera.classList.add("cursor-info");
                  cabecera.children[1].appendChild(document.createTextNode(texto));
                }
              }
            }
          },
        },
        colors: ['#1de9b6', '#40108e'],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
            columnWidth: '100%',
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '16px',
            fontFamily: 'Mulish',
            fontWeight: 'bold'
          },
          formatter: (val, a) => {
            let esPrestacional = this.resultados[0].indicador.area.clase.toLowerCase().trim()
                .includes('prestacion');
            let esAmbiental = this.resultados[0].indicador.area.clase.toLowerCase().trim()
                .includes('ambiental');

            if (esPrestacional && typeof this.resultados[a.dataPointIndex] !== "undefined") {
              let resultado = this.resultados[a.dataPointIndex]
                  .absoluto.resultadosSolCons[a.seriesIndex]["completo"];

              if (resultado.toLowerCase() === "no aplicable") return "Dna";

              return this.convertirAFlotante(resultado);
            } else if (esAmbiental && typeof this.resultados[a.dataPointIndex] !== "undefined") {
              let resultado = this.resultados[a.dataPointIndex]
                  .resultadosSolCons[a.seriesIndex][this.tipoResultado];
              let valorFloat = this.convertirAFlotante(resultado);

              return isNaN(valorFloat) ? 0 : valorFloat;
            }

            return Math.abs(val);
          },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 1,
            color: '#000',
            opacity: 0.9
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        yaxis: {
          min: (this.tipoArea == 'economicos') ? undefined : -10,
          max: (this.tipoArea == 'economicos') ? undefined : 10,
          labels: {
            show: true,
            align: "left",
            minWidth: this.tipoArea == 'economicos' ? 220 : 350,
            maxWidth: this.tipoArea == 'economicos' ? 350 : 350,
            style: {
              colors: "#40108e",
              fontSize: "13px",
              fontWeight: "bold",
              fontFamily: "Mulish",
              cssClass: "text-uppercase" + (this.labelClickeable ? " hand" : ""),
            },
            formatter: (value) => {
              if (typeof value != "string") return value;

              let txt = "";
              txt += this.tipoArea === 'economicos'
                  ? this.$t('coste_de', [value.toLowerCase()]) : value.toUpperCase();

              if (this.esGrupoPrestacional && txt.length > 40) {
                txt = txt.substring(0, 40).trim() + "..."
              }

              return txt + (this.labelClickeable ? " 〉" : "");
            }
          },
        },
        tooltip: {
          shared: false,
          custom: ({seriesIndex, dataPointIndex}) => {
            let resultado = this.resultados[dataPointIndex];
            let unidades = resultado.absoluto.resultadosSolCons[seriesIndex]['normaUnidad'];

            if (unidades == '(1-10)') unidades = '(adimensional)';

            unidades = unidades.replace('µ', '');

            let valor = resultado.absoluto.resultadosSolCons[seriesIndex][this.tipoResultado];
            if (this.esGrupoPrestacional) {
              let normaUnidades = unidades.split("::");
              let valorDato = resultado.resultadosSolCons[seriesIndex]['dermis'].trim();

              valor = `${valorDato} - ${normaUnidades[1]} - ${normaUnidades[0]}`;
              unidades = '';

              if (valorDato.trim().toLowerCase() === 'dato no disponible')
                valor += "<br>No se ha encontrado dato a asignar";
              else if (valorDato.trim().toLowerCase() === 'dato no aplicable')
                valor += "<br>No se puede realizar ensayo para este material";
            }

            return `<div class="tooltip-resultado">
                                        <span class="titulo">${resultado.absoluto.indicador.nombre}</span><br>
                                        ${valor} ${unidades}
                                    </div>`;
          },
        },
        xaxis: {
          categories: this.categoriasChart,
          style: {
            fontFamily: "Mulish",
          },
          labels: {
            trim: false,
            formatter: function (value) {
              return Math.abs(Math.round(value));
            }
          }
        }
      }
    }
  },
  methods: {
    convertirAFlotante(numero) {
      try {
        return parseFloat(numero.replace(",", "."));
      } catch (e) {
        return NaN;
      }
    }
  }
}
</script>

<style lang="scss">
.tooltip-resultado {
  padding: 10px;
  width: auto;
  font-weight: bolder;

  .titulo {
    font-weight: bolder;
  }
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "coste_de": "Coste de {0}",
    "Demolición inicial": "Coste de las operaciones necesarias para llevar a cabo la retirada del revestimiento existen y del resto de componentes para la correcta instalación del nuevo material.",
    "Fabricación": "Precio de todos aquellos materiales susceptibles de formar parte de 1m2 de solución constructiva. Valores obtenidos de la base de datos \"Generador de precios de la construcción. España\" de CYPE Ingenieros.",
    "Transporte": "Precio del transporte de los materiales de la solución constructiva desde el lugar de fabricación hasta la obra, teniendo en cuenta el peso de los materiales y el tipo de transporte empleado. Valores del coste de transporte obtenidos a partir de datos del Ministerio de Fomento.",
    "Construcción": "Coste de la instalación y/o ejecución en obra de los materiales, incluyendo el coste de la mano de obra, medios auxiliares y el coste de la eliminación de los residuos generados. Datos obtenidos de la base de datos \"Generador de precios de la construcción. España\" de CYPE Ingenieros.",
    "Limpieza": "Coste de las operaciones de limpieza asociadas a los materiales de recubrimiento durante el periodo establecido como ciclo de vida de referencia. Se incluyen, en función del escenario y del material seleccionado, los costes del agua, energía, mano de obra y/o detergentes utilizados.",
    "Reparación": "Coste de las operaciones asociadas al tratamiento correctovio del material de recubrimiento, que le permita recuperar una condición aceptable para alcanzar los comportamientos funcionales, técnicos y estéticos requeridos.",
    "Sustitucion": "Coste del fin de de vida material de recubrimiento existente y su posterior reposición (incluyendo el coste fabricación, transporte y construcción), considerando el total de dichas operaciones en función de la vida útil del material y del ciclo de vida de referencia.",
    "Fin de vida": "Incluye el coste de demolición del material de recubrimiento existente, el coste del transporte del 70% de dicha demolición a punto autorizado para su valorazación como nuevas materias primas y el coste del transporte y vertido del 30% restante en planta de gestión de residuos."
  }
}
</i18n>
<!--@formatter:on-->